import React, { useRef, useState, useEffect } from 'react';

import { Image, Button, ButtonGroup, VStack } from '@frontend/components';

type LogoFormControlProps = {
  onImageSelected: (src: string) => void;
  onFileCallback: (file: File) => void;
  src: string;
  isFromTemplate: boolean;
};
const LogoFormControl = (props: LogoFormControlProps): JSX.Element => {
  const inputRef = useRef();
  const [localImageSrc, setLocalImageSrc] = useState<string>(props.src);
  const handleFileUpload = (e) => {
    if (Object.keys(e.target.files).length) {
      const file = e.target.files[0];
      const src = URL.createObjectURL(file);
      if (localImageSrc?.length) {
        URL.revokeObjectURL(localImageSrc);
      }
      setLocalImageSrc(src);
      props.onImageSelected(src);
      props.onFileCallback(file);
    }
  };

  const handleClear = () => {
    if (localImageSrc?.length) {
      setLocalImageSrc('');
      props.onImageSelected('');
      URL.revokeObjectURL(localImageSrc);
    }
  };
  useEffect(() => {
    setLocalImageSrc(props.src);
  }, [props.src]);

  return (
    <>
      <VStack align={'flex-start'}>
        <ButtonGroup>
          <Button
            fontSize={'14px'}
            variant="link"
            isDisabled={props.isFromTemplate}
            onClick={() => inputRef?.current?.click()}
          >
            {localImageSrc ? 'Change file' : 'Choose file'}
          </Button>
          {localImageSrc && (
            <Button
              fontSize={'14px'}
              isDisabled={props.isFromTemplate}
              variant="link"
              onClick={handleClear}
            >
              Clear
            </Button>
          )}
        </ButtonGroup>
        {localImageSrc && (
          <Image maxWidth={'120px'} maxH={'52px'} src={localImageSrc} />
        )}

        <input
          ref={inputRef}
          id="file"
          type="file"
          accept="image/*"
          name="image"
          value={''}
          onChange={(e) => {
            handleFileUpload(e);
          }}
          style={{ display: 'none' }}
        />
      </VStack>
    </>
  );
};

export default LogoFormControl;
